import React from 'react';

import { IpcInstance } from '~src/bootstrap/ipc';

export const IpcContext = React.createContext<IpcInstance<any> | undefined>(undefined);

export function useIpc() {
  const ipc = React.useContext(IpcContext);
  if (ipc !== undefined) {
    return ipc;
  }
  throw 'IpcContext is not yet defined, you are probably using it in a wrong place';
}

export function useIpcStateSender<T>(stateKey: string, stateData: T) {
  const ipc = useIpc();

  React.useEffect(() => {
    if (stateData === undefined) {
      return;
    }

    ipc.send({
      name: stateKey,
      data: stateData,
    });
  }, [stateData]);
}

export function useIpcStateMirror<T>(stateKey: string) {
  const ipc = useIpc();

  const [state, setState] = React.useState<T | undefined>(undefined);

  ipc.listen(payload => {
    if (payload.name === stateKey) {
      setState(payload.data);
    }
  });

  return [state];
}
